import styled from "@emotion/styled";

export const CommunicationMainStyles = styled("div")`
  display: flex;
  position: absolute;
  z-index: 1000;

  opacity: 0;
  visibility: hidden;
  transition:
    visibility 0s linear 0.13s,
    opacity 0.13s linear;

  padding: 14px 20px 11px;
  /* background-color: #f8f8fd; */

  /* box-shadow: #000 0 0; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  /* box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px; */

  &.--visible {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s;
  }
`;
